var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        placement: "bottomRight",
        overlayClassName: "avatar-popover-overlay",
        overlayStyle: _vm.overlayStyle
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "div",
            {
              staticStyle: {
                "min-width": "200px",
                padding: "15px 12px",
                display: "flex",
                "align-items": "center"
              },
              style: _vm.note
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-right": "10px",
                    "border-radius": "50%",
                    width: "32px",
                    height: "32px",
                    "font-size": "20px",
                    "text-align": "center",
                    overflow: "hidden"
                  },
                  style: {
                    background: !_vm.userInfo.headImgUrl ? "#d1d1d1" : "#fff"
                  }
                },
                [
                  !_vm.userInfo.headImgUrl
                    ? _c("icon-font", {
                        staticClass: "gb-icon-user",
                        staticStyle: { color: "#fff" },
                        attrs: { type: "gb-icon-user" }
                      })
                    : _c("img", {
                        staticStyle: {
                          width: "32px",
                          height: "32px",
                          display: "block"
                        },
                        attrs: { src: _vm.userInfo.headImgUrl }
                      })
                ],
                1
              ),
              _c("div", { staticStyle: { flex: "1", "min-width": "0" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#1E1E28",
                      "font-size": "14px",
                      "font-weight": "bold"
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("userName")(_vm.userInfo)))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#484848",
                      "font-size": "12px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "min-width": "0" } },
                      [_vm._v(_vm._s(_vm.packageName))]
                    ),
                    _c("div", { staticClass: "btn_login" }, [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "margin-left": "13px",
                            color: "#ffffff"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMenuClick({ key: "user" })
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.i18nRender("layouts.upgrade")) +
                              " "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _c(
            "a-menu",
            {
              attrs: {
                mode: "inline",
                selectable: false,
                inlineIndent: 22,
                openKeys: _vm.openKeys
              },
              on: {
                "update:openKeys": function($event) {
                  _vm.openKeys = $event
                },
                "update:open-keys": function($event) {
                  _vm.openKeys = $event
                },
                click: _vm.handleMenuClick
              }
            },
            [
              _c("a-menu-item", { key: "home" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      padding: "12px 0"
                    }
                  },
                  [
                    _c("icon-font", {
                      staticClass: "iconFont",
                      attrs: { type: "gb-icon-a-01" }
                    }),
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "min-width": "0" } },
                      [_vm._v(_vm._s(_vm.i18nRender("layouts.usercenter")))]
                    )
                  ],
                  1
                )
              ]),
              _c("a-menu-item", { key: "accountSettings" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      padding: "12px 0"
                    }
                  },
                  [
                    _c("icon-font", {
                      staticClass: "iconFont",
                      attrs: { type: "gb-icon-a-02" }
                    }),
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "min-width": "0" } },
                      [
                        _vm._v(
                          _vm._s(_vm.i18nRender("layouts.accountSettings"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm.menus.length
                ? _c("a-menu-item", { key: "authority" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          padding: "12px 0"
                        }
                      },
                      [
                        _c("icon-font", {
                          staticClass: "iconFont",
                          attrs: { type: "gb-icon-a-03" }
                        }),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "min-width": "0" } },
                          [_vm._v(_vm._s(_vm.i18nRender("layouts.authority")))]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.menus.length
                ? _c("a-menu-item", { key: "store" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          padding: "12px 0"
                        }
                      },
                      [
                        _c("icon-font", {
                          staticClass: "iconFont",
                          attrs: { type: "gb-icon-dianpu2" }
                        }),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "min-width": "0" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.i18nRender("layouts.store.authorization")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c(
                "a-sub-menu",
                { key: "syl" },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        padding: "12px 0"
                      },
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _c("icon-font", {
                        staticClass: "iconFont",
                        attrs: { type: "gb-icon-a-04" }
                      }),
                      _c(
                        "div",
                        { staticStyle: { flex: "1", "min-width": "0" } },
                        [_vm._v(_vm._s(_vm.i18nRender("layouts.menusyl")))]
                      ),
                      _c("a-icon", {
                        staticStyle: {
                          "font-size": "12px",
                          transition: "all 0.3s"
                        },
                        style: {
                          transform: _vm.openKeys.includes("syl")
                            ? "rotate(90deg)"
                            : "rotate(0deg)"
                        },
                        attrs: { type: "right" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-menu-item",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        padding: "12px 0"
                      }
                    },
                    [
                      _c(
                        "a-tooltip",
                        { attrs: { placement: "top" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.i18nRender("layouts.menusyl.top"))
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "layout-syl-ob-item",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$store.dispatch(
                                    "entry/saveUseNewMenu",
                                    2
                                  )
                                }
                              }
                            },
                            [
                              _vm.useNewMenu === 2
                                ? _c("a-icon", { attrs: { type: "check" } })
                                : _vm._e(),
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/layout1.png"),
                                  alt: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "a-tooltip",
                        { attrs: { placement: "top" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.i18nRender("layouts.menusyl.left"))
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "layout-syl-ob-item",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$store.dispatch(
                                    "entry/saveUseNewMenu",
                                    1
                                  )
                                }
                              }
                            },
                            [
                              _vm.useNewMenu === 1
                                ? _c("a-icon", { attrs: { type: "check" } })
                                : _vm._e(),
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/layout2.png"),
                                  alt: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("a-menu-item", { key: "logout" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      padding: "12px 0"
                    }
                  },
                  [
                    _c("icon-font", {
                      staticClass: "iconFont",
                      attrs: { type: "gb-icon-a-05" }
                    }),
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "min-width": "0" } },
                      [_vm._v(_vm._s(_vm.i18nRender("layouts.logout")))]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-content__action" },
        [
          !_vm.userInfo.headImgUrl
            ? _c("icon-font", {
                staticClass: "gb-icon-user",
                attrs: { type: "gb-icon-user" }
              })
            : _c("img", {
                staticStyle: {
                  width: "22px",
                  height: "22px",
                  "border-radius": "50%"
                },
                attrs: { src: _vm.userInfo.headImgUrl }
              }),
          _c("span", { staticStyle: { "margin-left": "8px" } }, [
            _vm._v(_vm._s(_vm._f("userName")(_vm.userInfo)))
          ]),
          _c("icon-font", { attrs: { type: "gb-icon-xiala" } })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }